module.exports = __webpack_public_path__ + "media/images/応援ハシゴ割引_1000円_1280_480-9960d56d97c605860d8c5f88ef742b51.png";